import React, { useState } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Column, Row } from 'simple-flexbox';
import HeaderComponent from '../components/header/HeaderComponent';
import PrivateRoutes from './PrivateRoutes';
import Sd from './dashboard/Sd';
import SupportInboxWidget from './SupportInboxWidget';


const useStyles = createUseStyles({
  container: {
    position: 'relative',
    minHeight: '100vh',
    backgroundColor: '#f5f7fa',
  },
  mainBlock: {
    padding: '0px',
    overflowY: 'auto',
    height: '100vh',
    flexGrow: '1',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    backgroundColor: '#f5f7fa',
    '@media (max-width: 1080px)': {
      padding: '0px',
    },
    '@media (max-width: 768px)': {
      padding: '0px',
    },
  },
  contentBlock: {
    paddingTop: 64, // Exact height of the header
    animation: '$fadeIn 0.5s ease-in',
    minHeight: '100vh',
    '@media (max-width: 768px)': {
      paddingTop: 64,
    },
  },
  '@keyframes fadeIn': {
    from: {
      opacity: 0,
      transform: 'translateY(10px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  scrollToTop: {
    position: 'fixed',
    bottom: '120px',
    right: '30px',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: '#1976d2',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
    transition: 'all 0.3s ease',
    zIndex: 999,
    opacity: 0,
    visibility: 'hidden',
    transform: 'translateY(20px)',
    '&.visible': {
      opacity: 1,
      visibility: 'visible',
      transform: 'translateY(0)',
    },
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
    },
    '@media (max-width: 768px)': {
      bottom: '100px',
      right: '20px',
      width: '45px',
      height: '45px',
    },
  },
});

function PrivateSection() {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const [isDrawerOpen, setIsDrawerOpen] = useState(
    () => localStorage.getItem('sidebarOpen') !== 'false'
  );
  const [showScrollTop, setShowScrollTop] = useState(false);

  React.useEffect(() => {
    localStorage.setItem('sidebarOpen', String(isDrawerOpen));
  }, [isDrawerOpen]);

  const scrollToTop = () => {
    const mainBlock = document.querySelector(`.${classes.mainBlock}`);
    if (mainBlock) {
      mainBlock.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Handle scroll event for scroll-to-top button
  React.useEffect(() => {
    const mainBlock = document.querySelector(`.${classes.mainBlock}`);

    const handleScroll = () => {
      if (mainBlock && mainBlock.scrollTop > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    if (mainBlock) {
      mainBlock.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (mainBlock) {
        mainBlock.removeEventListener('scroll', handleScroll);
      }
    };
  }, [classes.mainBlock]);

  return (
    <>
      <HeaderComponent
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
      />

      <Row className={classes.container}>
        <Sd
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
        />

        <Column flexGrow={1} className={classes.mainBlock}>
          <div className={classes.contentBlock}>
            <PrivateRoutes />

            <SupportInboxWidget />

            {/* Scroll to Top Button */}
            <button
              className={`${classes.scrollToTop} ${showScrollTop ? 'visible' : ''}`}
              onClick={scrollToTop}
              aria-label="Scroll to top"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="18 15 12 9 6 15"></polyline>
              </svg>
            </button>
          </div>
        </Column>
      </Row>
    </>
  );
}

export default PrivateSection;